import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { ThemeColor, ThemeTonalRange } from '@philips-emr/tws-constants';
import { FileService } from '@philips-emr/tws-core/lib/services';
import DefaultFileHandler from '@philips-emr/tws-core/lib/services/file/default-file-handler';
import FileHandlerConfiguration from '@philips-emr/tws-core/lib/services/file/file-handler-configuration';

export interface Wsuite {
  dsColorRange?: ThemeColor;
  dsUrlLogoFooter?: string;
  dsUrlLogoHeaderLogin?: string;
  dsLinkFacebook?: string;
  dsLinkInstagram?: string;
  dsLinkLinkedin?: string;
  dsLinkTwitter?: string;
  dsLinkYoutube?: string;
  dsAddress?: string;
  nrContactPhone?: string;
  dsEmailFooter?: string;
}

class Configuration {

  private static data: Promise<Wsuite>;
  private static tonalRange: ThemeTonalRange;

  static getData(): Promise<Wsuite> {
    return this.data;
  }

  static setData(config: Promise<Wsuite>): void {
    this.data = config;
  }

  static getTonalRange(): ThemeTonalRange {
    return this.tonalRange;
  }

  static setTonalRange(tonalRange: ThemeTonalRange): void {
    this.tonalRange = tonalRange;
  }

  static setFileuploaderConfig(): void {
    const config = new FileHandlerConfiguration();
    config.uploadUrl = ENDPOINTS.POST.UPLOAD_FILE;

    const handler = new DefaultFileHandler();
    handler.setConfiguration(config);

    FileService.setFileHandler(handler);
  }
}

export {
  Configuration,
};
